import React from "react";
import { Table, Spinner } from "react-bootstrap";
import styled from "styled-components";
import { isAllValuesEmpty } from "../../../Utills/objectUtils";

// Move this OUTSIDE the component!
const StyledTable = styled(Table)`
  border-collapse: collapse !important;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid #ccc;
`;

export default function CustomTable({ 
  columns = [], 
  rows = [], 
  isLoading = false, 
  noDataText = "No data found!",
  striped = true,
  bordered = true,
  responsive = true,
  size = "md"
}) {
  // Helper function to check if cell content is empty
 
console.log(rows,'data')
  // Helper function to render cell content
  const renderCellContent = (content) => {

 
    if (isAllValuesEmpty(content)) {
      return <span className="d-flex justify-content-center">{noDataText}</span>;
    }
    return content;
  };

  // Helper function to get column width
  const getColumnWidth = (column) => {
    if (typeof column === 'object' && column.width) {
      return column.width;
    }
    return '210px';
  };

  // Helper function to get column text
  const getColumnText = (column) => {
    if (typeof column === "object" && column !== null && "text" in column) {
      return column.text;
    }
    return column;
  };

  return (
    <TableWrapper>
      <StyledTable
        bordered={bordered}
        responsive={responsive}
        size={size}
        className="custom-data-table"
      >
        <thead>
          <TableRow>
            {columns.map((col, idx) => (
              <TableHeader 
                key={idx} 
                style={{ minWidth: getColumnWidth(col) }}
              >
                {getColumnText(col)}
              </TableHeader>
            ))}
          </TableRow>
        </thead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center">
                <Spinner size="sm" animation="border" variant="primary" />
              </TableCell>
            </TableRow>
          ) : rows.length > 0 ? (
            rows.map((row, i) => (
              <TableRow key={i}>
                {row.map((cell, j) => (
                  <TableCell 
                    key={j}
                    style={{ width: getColumnWidth(columns[j]) }}
                  >
                    {renderCellContent(cell)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center">
                {noDataText}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
}

// Styled components
const TableWrapper = styled.div`
  margin: 0 auto;
  padding: 10px 0;
  overflow-x: auto;
  max-width: 94vw;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #2979ff;
  color: #fff;
  font-weight: bold;
  height: 48px;
`;

const TableBody = styled.tbody``;

const TableCell = styled.td`
  padding: 10px;
  border: 1px solid #ccc;
  vertical-align: middle;
  background: #fff;
  
  .text-muted {
    color: #6c757d !important;
    font-style: italic;
  }
`;
